/**
 * PODGLĄD HURTU — rachunek indeksów po „Pomiń zablokowane" (etap 3, 29.09.2026). Bez Reacta.
 *
 * ⚠️ DWIE NUMERACJE: serwer liczy `index` w liście, którą właśnie dostał (po pominięciach), a człowiek
 * zna numery z listy „do wysłania" w siatce. `aktywne[i]` to pozycja i-tej wysłanej zmiany w tamtej
 * liście — bez tego przemapowania drugi podgląd pokazywałby inne numery niż pierwszy.
 */

/** Indeksy z siatki bez tych, które serwer zablokował w ostatnim podglądzie. */
export function bezZablokowanych(aktywne: readonly number[], zablokowane: readonly { index: number }[]): number[] {
  const zle = new Set(zablokowane.map((z) => aktywne[z.index]));
  return aktywne.filter((i) => !zle.has(i));
}

/** Numer zmiany tak, jak widział ją człowiek na liście „do wysłania" — od 1. */
export const numerZmiany = (aktywne: readonly number[], index: number): number => (aktywne[index] ?? index) + 1;
